var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"ImpersionationWarnComp"}},[_vm._v("\n  ❗️ Impersonation en cours user : "),_c('b',[_vm._v(_vm._s(_vm.$auth.getUserSlug())+" ")]),_vm._v("️\n")])}
var staticRenderFns = []

export { render, staticRenderFns }